import React, { useState, useEffect, useContext } from "react";
import { Grid, Container, makeStyles, TableBody, TableHead, TablePagination } from "@material-ui/core";
import { Loader, SimpleToolbar, Toast, Drawer, StyledTableCell, StyledTableRow, BaseTable } from "../components";
import { productsServices } from "../services";
import { AuthContext } from "../context";
import { formatDate } from "../helpers";
import { useDrawer } from "../hooks";

export default function SamplesToRunOutScreen(props) {
	const classes = useStyles();
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [limit, setLimit] = useState(100);
	const [page, setPage] = useState(1);
	const [count, setCount] = useState(0);
	const { authState, signOut } = useContext(AuthContext);
	const [toast, setToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const { isOpen, setIsOpen } = useDrawer();

	const getProducts = async ({ text }) => {
		try {
			setLoading(true);
			const { status, response } = await productsServices.getSamplesToExpire({
				page,
				limit,
				laboratoryId: authState.user.laboratory._id,
				token: authState.token,
				text,
			});
			setLoading(false);
			if (status === 200) {
				setProducts(response.products);
				setLimit(response.limit);
				setCount(response.total);
				setPage(response.page);
			} else if (status === 401) {
				signOut();
			} else if (response.error) {
				setToastMessage(response.error.message);
				setToast(true);
			}
		} catch (e) {
			setLoading(false);
			console.log(e);
		}
	};

	useEffect(() => {
		getProducts({ text: " " });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, limit, authState]);

	return (
		<>
			<Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
			<Grid container className={classes.container} style={{ flex: 1 }}>
				{loading && <Loader loading={true} />}
				<Toast open={toast} message={toastMessage} close={() => setToast(false)} />
				<Grid item sm={12}>
					<div className={classes.root}>
						<Container maxWidth={false}>
							{
								<SimpleToolbar
									hideExport={authState.user.laboratory}
									table={"tableproducts"}
									filename={"productes"}
									onFilter={(text) => getProducts({ text })}
									uploadproducts
									isOpen={isOpen}
									setIsOpen={(value) => setIsOpen(value)}
								/>
							}
							<BaseTable tableId="tableproducts">
								<TableHead>
									<StyledTableRow>
										{authState.user.role.name === "LABORATORY_ADMIN" && <StyledTableCell>Unidad de negocio</StyledTableCell>}
										<StyledTableCell>Nombre</StyledTableCell>
										<StyledTableCell>Registro</StyledTableCell>
										<StyledTableCell>Vigencia</StyledTableCell>
										<StyledTableCell>Fecha de expedición</StyledTableCell>
										<StyledTableCell>Fecha de expiración</StyledTableCell>
									</StyledTableRow>
								</TableHead>
								<TableBody>
									{products.map((product, index) => (
										<StyledTableRow hover key={product._id}>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.name}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.isp}</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>{product.validity} Dias</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{formatDate(new Date(product.updatedAt))}
											</StyledTableCell>
											<StyledTableCell style={{ color: index % 2 === 0 ? "#192A7F" : "#2196C0" }}>
												{formatDate(new Date(product.expireAt))}
											</StyledTableCell>
											{/*!authState.user.laboratory && (
                          <StyledTableCell>{product.birthdate !== "Invalid date" ? product.birthdate : "N/A"}</StyledTableCell>
													<>
														<StyledTableCell>{product.phone ? product.phone : "N/A"}</StyledTableCell>
														<StyledTableCell>{product.activityPhone ? product.activityPhone : "N/A"}</StyledTableCell>
														<StyledTableCell>{product.email ? product.email : "N/A"}</StyledTableCell>
													</>
												)}
												<StyledTableCell>{product.specialties[0].name}</StyledTableCell>
												<StyledTableCell>{product.specialties[1] ? product.specialties[1].name : "N/A"}</StyledTableCell>
												<StyledTableCell>{product.specialties[2] ? product.specialties[2].name : "N/A"}</StyledTableCell>
												<StyledTableCell>{product.userId ? "Activo" : "Inactivo"}</StyledTableCell>
                    */}
											{/* <StyledTableCell>
                                    <IconButton>
                                        <Tooltip title="Editar product" aria-label="edit">
                                        <Edit />
                                        </Tooltip>
                                    </IconButton>
                                    <IconButton>
                                        <Tooltip title='Activar product' aria-label="active">
                                        <CheckCircle />
                                        </Tooltip>
                                    </IconButton>
                                    <IconButton>
                                        <Tooltip title="Borrar product" aria-label="delete">
                                        <Delete />
                                        </Tooltip>
                                    </IconButton>
                                    </StyledTableCell> */}
										</StyledTableRow>
									))}
								</TableBody>
							</BaseTable>
							<TablePagination
								labelRowsPerPage="Registros por página"
								component="div"
								count={count}
								onChangeRowsPerPage={(e) => {
									setLimit(e.target.value);
								}}
								onChangePage={(e, page) => {
									setPage(page + 1);
								}}
								page={page - 1}
								rowsPerPage={limit}
								rowsPerPageOptions={[10, 25, 50, 100]}
								classes={{ root: classes.pagination }}
							/>
						</Container>
					</div>
				</Grid>
			</Grid>
		</>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		paddingBottom: theme.spacing(2),
		paddingTop: theme.spacing(2),
	},
	pagination: {
		color: theme.palette.secondary.main,
		[theme.breakpoints.down("xs")]: {
			position: "absolute",
			bottom: 0,
		},
	},
}));
